import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import FounderMessage from './pages/FounderMessage';
import MissionVision from './pages/MissionVision';
import CompanyRegistration from './pages/CompanyRegistration';
import IsoCertificationPage from './pages/IsoCertificationPage';
import ContactPage from './pages/ContactPage';
import FranchisePage from './pages/FranchisePage';
import GlobalStickyHub from './components/GlobalStickyHub';

function App() {
  return (
    <Router>
      <Navbar />
      <GlobalStickyHub />
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="/about" element={<About />} />
           <Route path="/mission-vision" element={<MissionVision />} />
           <Route path="/founder-message" element={<FounderMessage />} />
           <Route path="/company-registration" element={<CompanyRegistration />} />
           <Route path="/iso-certificationPage" element={<IsoCertificationPage />} />
           <Route path="/contact" element={<ContactPage />} />
           <Route path="/franchise-page" element={<FranchisePage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;